export const DEPARTMENT_PAGE_LOAD_READY = 'DEPARTMENT_PAGE_LOAD_READY'; // eslint-disable-line
